<template>
	<div class="wrapper">
		<b-row>
			<b-col cols="12">
				<b-card header-tag="header">
					<template v-slot:header>
						<i class="icon-clock"></i> Overtime settings
					</template>

					<b-card-body>
						<b-form>
							<!-- Office selector -->
							<b-form-group
								label="Office"
								label-for="office"
								:label-cols="3"
								:horizontal="true">
								<multiselect
									id="office"
									v-model="selectedOffice"
									:options="officeList"
									:close-on-select="false"
									:searchable="true"
									label="name"
									placeholder="Pick a value"
									@input="loadSettingsForOffice()">
								</multiselect>
							</b-form-group>

							<!-- Single OT mode dropdown -->
							<b-form-group
								v-if="otSetting"
								label="Overtime calculation mode"
								:label-cols="3"
								:horizontal="true">
								<b-form-select
									v-model="otSetting.generalSettingsKey.setValue"
									:options="otOptions"
									class="mb-3"
									value-field="value"
									text-field="name"
								></b-form-select>
							</b-form-group>

							<div class="form-actions">
								<b-button
									type="button"
									variant="success"
									:disabled="!selectedOffice || !otSetting"
									@click="save()">
									Save
								</b-button>
							</div>
						</b-form>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import toastService from "@/services/toastService";
import officeService from "@/services/officeService";
import generalSettingsService from "@/services/generalSettingsService";
import generalSettingsGroupIds from "@/services/generalSettingsGroupIds";
import Multiselect from "vue-multiselect";

export default {
	name: "OvertimeGeneralSettings",
	components: { Multiselect },
	data() {
		return {
			officeList: [],
			selectedOffice: null,
			// we’ll keep only the single setting object here
			otSetting: null,
			otOptions: [] // parsed enum values
		};
	},
	methods: {
		loadSettingsForOffice() {
			this.otSetting = null;
			this.otOptions = [];
			if (!this.selectedOffice) return;

			generalSettingsService.getGeneralSettings(
				{ officeId: this.selectedOffice.id, groupId: generalSettingsGroupIds.OVERTIME_SETTINGS_ID },
				(data) => {
					// find ONLY the overtime calculation mode key
					const row = data.find(
						d => d.generalSettingsKey && d.generalSettingsKey.keyCode === "OVERTIME_CALCULATION_MODE"
					);
					if (!row) {
						toastService.showErrorToast("Overtime setting not found for this office/group");
						return;
					}
					// parse possible values safely
					try {
						if (row.generalSettingsKey.possibleValues && typeof row.generalSettingsKey.possibleValues === "string") {
							row.generalSettingsKey.possibleValues = JSON.parse(row.generalSettingsKey.possibleValues);
						}
					} catch (e) {
						// ignore parse error; UI will still show input if needed
					}
					this.otOptions = (row.generalSettingsKey.possibleValues && row.generalSettingsKey.possibleValues.values) || [];
					this.otSetting = row;
				},
				(msg) => toastService.showErrorToast(msg || "Failed to load settings")
			);
		},

		save() {
			if (!this.selectedOffice || !this.otSetting) {
				return toastService.showErrorToast("Please select an office");
			}
			const payload = {
				officeId: this.selectedOffice.id,
				groupId: generalSettingsGroupIds.OVERTIME_SETTINGS_ID,
				settings: [
					{
						groupId: this.otSetting.groupId,                            // 10
						keyId: this.otSetting.generalSettingsKey.id,                // 39
						keyCode: this.otSetting.generalSettingsKey.keyCode,         // 'OVERTIME_CALCULATION_MODE'
						setValue: this.otSetting.generalSettingsKey.setValue,       // enum value
						officeGroupKeyId: this.otSetting.generalSettingsKey.officeGroupKeyId
					}
				]
			};
			generalSettingsService.updateGeneralSettingsOfAnOffice(
				payload,
				() => toastService.showSuccessToast("Updated Successfully"),
				() => toastService.showErrorToast("Update failed")
			);
		}
	},
	mounted() {
		officeService.getOfficeList(r => { this.officeList = r; });
	}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
